// This program has been developed by students from the bachelor Computer Science at
// Utrecht University within the Software Project course.
// © Copyright Utrecht University (Department of Information and Computing Sciences)

import { fetchWithToken } from '../../../../shared/api'

// Handler that creates the JSON and posts the selection to the server
export async function postSavedSelection(eu_pnumbers, saveName) {
  var success = false

  // Call to server: /api/saveselection
  const response = await fetchWithToken(
    `${process.env.PUBLIC_URL}/api/saveselection/`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        name: saveName,
        eu_pnumbers: eu_pnumbers,
      }),
    }
  )

  // If the response returns ok, then saving the selection
  // was successful
  if (response.ok) {
    success = true
  }

  return success
}

const SELECTION_PREFIX = 'selection_';
// Handler that creates the JSON and saves the selection to local storage with a prefix
export default async function saveSelectionLocally(eu_pnumbers, saveName, selectionNote) {
  try {
    const storageKey = `${SELECTION_PREFIX}${saveName}`;
    const saveData = {
      name: saveName,
      eu_pnumbers: eu_pnumbers,
      selectionNote: selectionNote,
      saveDate: new Date().toLocaleString(),
      id: saveName
    };

    localStorage.setItem(storageKey, JSON.stringify(saveData));
    return true; // Indicate success
  } catch (error) {
    console.error("Error saving to local storage:", error);
    return false; // Indicate failure
  }
}
